import { useNavigate } from "react-router-dom";
import { usePropertyStore } from "../../store/usePropertyStore";

const BannerV6 = ({ chooseType }) => {
    const navigate = useNavigate();

    const { simpleFilter, setSimpleFilter, applySimpleFilter, setDirect } = usePropertyStore();

    const propertyTypes = chooseType?.property_type || [];
    const provinces = chooseType?.province || [];
    const cities = chooseType?.city || [];

    const handleSearch = () => {
        applySimpleFilter();
        setDirect(true);
        navigate("/property-list");
    };

    return (
        <div className="ltn__slider-area ltn__slider-4 position-relative  ltn__primary-bg">
            <div className="ltn__slide-one-active----- slick-slide-arrow-1----- slick-slide-dots-1----- arrow-white----- ltn__slide-animation-active">
                <div
                    className="ltn__slide-item ltn__slide-item-2 ltn__slide-item-3-normal--- ltn__slide-item-3 bg-image bg-overlay-theme-black-60"
                    style={{
                        backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/property.jpg)`,
                    }}
                >
                    <div className="ltn__slide-item-inner text-center">
                        <div className="container relative">
                            <div className="row">
                                <div className="col-lg-12 align-self-center">
                                    <div className="slide-item-car-dealer-form">
                                        <div className="section-title-area ltn__section-title-2 text-center">
                                            <h1 className="section-title text-color-white">
                                                Temukan{" "}
                                                <span className="ltn__secondary-color-3">
                                                    Properti
                                                </span>{" "}
                                                Impian Anda
                                            </h1>
                                        </div>

                                        <div className="ltn__car-dealer-form-tab">
                                            <div className="tab-content pb-10">
                                                <div
                                                    className="tab-pane fade active show"
                                                    id="ltn__form_tab_1_1"
                                                >
                                                    <div className="car-dealer-form-inner">
                                                        <form className="ltn__car-dealer-form-box row">
                                                            {/* TIPE PROPERTI */}
                                                            <div className="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-car col-lg-3 col-md-6">
                                                                <select
                                                                    className="nice-select"
                                                                    value={
                                                                        simpleFilter.property_type
                                                                    }
                                                                    onChange={(e) =>
                                                                        setSimpleFilter(
                                                                            "property_type",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">
                                                                        Tipe Properti
                                                                    </option>
                                                                    {propertyTypes.map((type) => (
                                                                        <option
                                                                            key={type}
                                                                            value={type}
                                                                        >
                                                                            {type}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {/* PROVINSI */}
                                                            <div className="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-meter col-lg-3 col-md-6">
                                                                <select
                                                                    className="nice-select"
                                                                    value={simpleFilter.province}
                                                                    onChange={(e) =>
                                                                        setSimpleFilter(
                                                                            "province",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">
                                                                        Provinsi
                                                                    </option>
                                                                    {provinces.map((p) => (
                                                                        <option key={p} value={p}>
                                                                            {p}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {/* KOTA */}
                                                            <div className="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-calendar col-lg-3 col-md-6">
                                                                <select
                                                                    className="nice-select"
                                                                    value={simpleFilter.city}
                                                                    onChange={(e) =>
                                                                        setSimpleFilter(
                                                                            "city",
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">Kota</option>
                                                                    {cities.map((c) => (
                                                                        <option key={c} value={c}>
                                                                            {c}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            {/* BUTTON CARI */}
                                                            <div className="ltn__car-dealer-form-item ltn__custom-icon ltn__icon-calendar col-lg-3 col-md-6">
                                                                <div className="btn-wrapper text-center mt-0 go-top">
                                                                    <button
                                                                        type="button"
                                                                        onClick={handleSearch}
                                                                        className="btn theme-btn-1 btn-effect-1 text-uppercase"
                                                                    >
                                                                        Cari Properti
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerV6;
